import { render, staticRenderFns } from "./myList.vue?vue&type=template&id=4d413b44&scoped=true&"
import script from "./myList.vue?vue&type=script&lang=js&"
export * from "./myList.vue?vue&type=script&lang=js&"
import style0 from "./myList.vue?vue&type=style&index=0&id=4d413b44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d413b44",
  null
  
)

export default component.exports